export enum CompanyTypes {
    CFI = 1,
    DEALER = 2,
    DISTRIBUTOR = 3,
    MFR = 4,
    SERVICE_PROVIDER = 5,
    EEPRO = 10
}

export enum InstallerType {
    CFI = 3600,
    CCI = 3601,
    PlumbingInstaller = 3602
}

export enum OrderStatus {
    Open = 10,
    Pending = 15,
    Hold = 20,
    Closed = 30,
    Cancelled = 40
}

export enum ROType {
    Retail = 140,
    AddOn = 141,
    Display = 142,
    Sample = 143,
    Measure = 144,
    Warranty = 145,
    Vanity = 146,
    VanityAddOn = 147,
    DisplayAdmin = 148,
    CFICompensation = 150,
    CabinetMeasureOrder = 160,
    CabinetInstallOrder = 161,
    Plumbing = 170
}

export enum MOType {
    Material = 120,
    Stocking = 121,
    Replacement = 122,
    Warranty = 123,
    Literature = 124,
    Sink = 125,
    Sample = 126,
    Display = 127,
    DistributorReplacementSink = 128,
    DisplayAdmin = 129,
    SampleAdmin = 130,
    CFICompensation = 131
}

export enum ProductCatalog {
    Material = 1,
    Retail = 2
}

export enum ProductLine {
    Granite = 1,
    Wood = 4,
    SmallProjects = 8,
    LaminateInstall = 10,
    LaminateDelivered = 12,
    Plumbing = 14,
    Cabinets = 17
}

export enum AR {
    LeadContactCustomer = 10,
    LeadScheduleAppointment = 20,
    LeadSubmitEstimate = 30,
    ManualEstimateSubmittal = 35,
    LeadPendingSale = 40,
    DealertoReviewEstimate = 50,
    CfiToEnterTemplateDate = 110,
    CfiToContactCustomer = 111,
    CfiToEnterReadyToMeasureOrTemplateDate = 112,
    CfiToEnterActualMeasureDate = 115,
    ScheduleDisconnect = 116,
    CfiToUploadTemplateChecklist = 117,
    CfiAssistanceRequested = 118,
    ScheduleReconnect = 119,
    CfiToConfirmOrChangeOrder = 120,
    SubmitManualChangeOrder = 121,
    DealerToConfirmChangeOrder = 122,
    UploadVanityOrderForm = 123,
    UploadLaminateOrderForm = 124,
    CorporateToAcceptChangeOrder = 125,
    SageToApproveChangeOrder = 126,
    PendingPostTemplatePayment = 127,
    ConfirmChangeOrderAccepted = 128,
    WaitingPostTemplateCustomerApproval = 129,
    CfiToOrderMaterials = 130,
    CfiToPrintPackingSlip = 133,
    DealerToSubmitCabinetDesign = 134,
    DealerToEnterEstimatedCabinetDeliveryDate = 135,
    DealerToEnterCabinetShipDate = 136,
    DealerToEnterCabinetPOReceivedDate = 137,
    InstallerToVerifyCabinetQuality = 138,
    DistributorToValidateShipDate = 140,
    DistributorToValidateDeliveryDate = 141,
    CfiToEnterScheduledInstallDate = 143,
    CfiToEnterActualInstallDate = 145,
    CfiToUploadInstallationPhotos = 147,
    DistributorToEnterShipDate = 150,
    DistributorToEnterDeliveryDate = 151,
    InstallerToEnterActualInstallStartDate = 155,
    InstallerToEnterLowerCabinetsPlumbLevelDate = 156,
    InstallerToEnterActualInstallCompletionDate = 157,
    CfiToUploadCocInvoice = 160,
    InstallerToUploadVerificationForm = 162,
    SageToInvoiceLowes = 170,
    LowesToTransferFunds = 190,
    SageToVerifyCancellation = 195,
    VerifyCancelledPostTemplate = 197,
    MOSageToCorrectCfiProductAssignment = 204,
    MOSageToCorrectCfiDistributorAssignment = 205,
    SageToIssueInvoiceToCFI = 215,
    CfiToPayInvoice = 225,
    MODistributorToValidateShipDate = 240,
    MODistributorToValidateDeliveryDate = 241,
    MODistributorToApproveCancelation = 244,
    MODistributorToEnterShipDate = 250,
    MODistributorToEnterDeliveryDate = 251,
    SageToApproveClaim = 255,
    PODistributorToValidateShipDate = 340,
    PODistributorToValidateDeliveryDate = 341,
    POSageToCorrectPO = 343,
    PODistributorToApproveCancelation = 344,
    POSageToReassignOrWaitForStock = 345,
    PODistributorToEnterShipDate = 350,
    PODistributorToEnterDeliveryDate = 351,
    PODistributorToInvoice = 360,
    POSageToVerifyOverage = 365,
    POServiceProviderToEnterServiceDate = 370,
    POServiceProviderToInvoice = 380,
    POSageToPayInvoice = 390,
    WOCfiToContactCustomer = 410,
    WOCfiToScheduleAppointment = 420,
    WOCfoToEnterWorkCompleteDate = 430,
    WOCfiToUploadWOC = 440,
    WOReadyForClosure = 490,
    CfiValidateChangeOrder = 9401,
    CfiUploadPostTemplateDrawing = 9402
}

export enum KindOfOrder {
    Estimate = 210,
    EstimatePOUpload = 2100,
    RetailOrder = 211,
    MaterialOrder = 213,
    PurchaseOrder = 215,
    WorkOrder = 217
}

export enum NoteType {
    General = 2600,
    ChangeRequest = 2601,
    AccessPoint = 2602
}

export enum FileTypes {
    //Common
    Drawing = 60,
    Other = 61,
    DisplayPhoto = 62,
    ServiceRequest = 63,
    WarrantyClaimForm = 64,
    InspectionReport = 65,
    EstimateDrawing = 66,
    PostTemplateDrawing = 67,
    // RO
    COC = 70,
    CfiInvoice = 71,
    RoMaterial = 72,
    DisplayCoc = 73,
    UploadCabinetDrawing = 74,
    UploadPO = 75,
    SlabViewingWaiver = 76,
    VanityOrderForm = 77,
    PostTemplateDetails = 78,
    CEA = 79,
    CabinetMeasureWorksheet = 96,
    CabinetDesignPacket = 97,
    CabinetQualityCheckWorksheet = 98,
    OrderDetailsConfirmation = 100,
    JobContract = 101,
    DetailWorksheet = 102,
    CFIChangeRequest = 103,
    LaminateOrderForm = 104,
    TemplateChecklist = 105,
    PostTemplateDetailsCFIPrice = 106,
    UnsignedCOC = 107,
    PostInstallChecklist = 116,
    WorkVerificationForm = 8000,
    UnsignedWorkVerificationForm = 8001,
    BlankCabinetMeasureWorksheet = 8002,
    BlankCabinetQualityCheckWorksheet = 8003,
    UnsignedCEA = 8004,
    // MO
    Material = 80,
    SageInvoice = 81,
    // PO
    DistributorInvoice = 90,
    BillOfLanding = 91,
    DealerPO = 92,
    CreditMemo = 93,
    PackingList = 94,
    // WO
    WOC = 110,
    ProofOfDelivery = 111
}

export enum StockingOrderWorkflow {
    MOWillBeOnHoldToReview = 800,
    ReleaseMOWithAnInvoice = 801,
    ReleaseMOWithACredit = 802,
    Blocked = 803
}

export enum SalesChannels {
    LowesStocking = 1,
    LowesRetail = 2,
    Other = 4
}

export enum QuoteStatus {
    Open = 1000,
    Expired = 1010,
    Closed = 1020,
    Hold = 1030,
    Cancelled = 1040,
    Incomplete = 1050,
    Pending = 1060
}

export enum QuoteTypes {
    EasyEstimator = 5500,
    Lead = 5501,
    EasyEstimator2 = 5502,
    EEPro = 5503,
    WinApp = 5504,
    EESync = 5505,
    EasyEstimator3 = 5506,
}

export enum OrderTypes {
    RetailOrder = 5600,
    IMEOrder = 5610,
    MeasureOrder = 5620,
    WorkOrder = 5630,
    MaterialOrder = 5640,
    Lead = 5650,
    Estimate = 5660
}

export enum ChangeOrderType {
    RetailOrder = 5700,
    IMEOrder = 5710,
    MeasureOrder = 5720,
    AddOnOrder = 5730
}

export enum ChangeOrderStatus {
    Dealer = 5800,
    Customer = 5810,
    Sage = 5820,
    Corporate = 5830,
    HausPro = 5840
}

export enum PendingReason {
    Other = 6220,
    WaitingOnMaterial = 6200
}

export enum PendingType {
    Customer = 6000,
    Material = 6010,
    Store = 6020
}

export enum ScriptFileType {
    InitialContact = 1,
    TemplateChecklist = 2,
    InstallChecklist = 3,
    PostInstall = 4,
    ChangeOrder = 5,
    CabinetInstallerChangeOrder = 6,
    CabinetInstallerScheduleMeasurement = 7,
    CabinetInstallerScheduleDevilery = 8,
    PlumbingSchedule = 9
}

export enum Environment {
    Sage,
    HausPro
}

export enum BusinessFlow {
    FD = 1601,
    CTG = 1602,
    Online = 1603,
    Lowes = 1620
}